export default __webpack_public_path__ + "media/images/images_v2/onglet-rightclick1-6814ea0ab05ce14d96867cfaedd38d10.png";